import React from "react";

export default function ShippingPolicy() {
  const sections = [
    {
      num: "01",
      eyebrow: "India",
      title: "Domestic Shipping",
      content: (
        <div className="sp-items">
          <div className="sp-item">
            <span className="sp-dash">—</span>
            <p className="sp-text">We ship across all serviceable pin codes in India through registered domestic courier partners and/or India Speed Post.</p>
          </div>
          <div className="sp-item">
            <span className="sp-dash">—</span>
            <p className="sp-text">Standard orders are dispatched within <strong>3–5 business days</strong> from the date of payment confirmation. Made-to-order or custom pieces may require up to <strong>7 business days</strong> before dispatch.</p>
          </div>
          <div className="sp-item">
            <span className="sp-dash">—</span>
            <p className="sp-text">Estimated delivery after dispatch is typically <strong>4–7 business days</strong> depending on your location. Remote or non-metro areas may experience slightly longer timelines.</p>
          </div>
        </div>
      ),
    },
    {
      num: "02",
      eyebrow: "Global",
      title: "International Shipping",
      content: (
        <div className="sp-items">
          <div className="sp-item">
            <span className="sp-dash">—</span>
            <p className="sp-text">We ship internationally through registered courier companies and/or International Speed Post. Delivery timelines vary by destination country and are subject to local customs procedures.</p>
          </div>
          <div className="sp-item">
            <span className="sp-dash">—</span>
            <p className="sp-text">International customers are responsible for any customs duties, import taxes, or local levies applicable in their country. VESHH-EON does not cover these charges.</p>
          </div>
          <div className="sp-item">
            <span className="sp-dash">—</span>
            <p className="sp-text">International orders may be subject to customs inspections which can cause additional delays beyond our control.</p>
          </div>
        </div>
      ),
    },
    {
      num: "03",
      eyebrow: "Cost",
      title: "Shipping Charges",
      content: (
        <div className="sp-items">
          <div className="sp-item">
            <span className="sp-dash">—</span>
            <p className="sp-text">Shipping charges, if applicable, are calculated at checkout based on your delivery location and order weight. The final shipping cost will be clearly displayed before you confirm your order.</p>
          </div>
          <div className="sp-item">
            <span className="sp-dash">—</span>
            <p className="sp-text">We periodically offer free shipping promotions. Any such offer will be clearly communicated on the website and applied automatically at checkout.</p>
          </div>
        </div>
      ),
    },
    {
      num: "04",
      eyebrow: "Updates",
      title: "Order Tracking",
      content: (
        <div className="sp-items">
          <div className="sp-item">
            <span className="sp-dash">—</span>
            <p className="sp-text">Once your order is dispatched, you will receive a shipment confirmation on your registered email address along with a tracking number and courier partner details.</p>
          </div>
          <div className="sp-item">
            <span className="sp-dash">—</span>
            <p className="sp-text">You can also track your order directly from the <strong>Order Tracking</strong> section on our website using your Order ID.</p>
          </div>
          <div className="sp-item">
            <span className="sp-dash">—</span>
            <p className="sp-text">If you haven't received a tracking update within <strong>7 business days</strong> of placing your order, please reach out to us at <strong>support@veshheon.in</strong>.</p>
          </div>
        </div>
      ),
    },
    {
      num: "05",
      eyebrow: "Liability",
      title: "Delivery & Responsibility",
      content: (
        <div className="sp-items">
          <div className="sp-item">
            <span className="sp-dash">—</span>
            <p className="sp-text">VESHH-EON guarantees dispatch within the committed timeframe. Once handed over to the courier partner, delivery timelines are subject to the courier company's operations and are outside our direct control.</p>
          </div>
          <div className="sp-item">
            <span className="sp-dash">—</span>
            <p className="sp-text">It is your responsibility to provide an accurate and complete delivery address at checkout. We shall not be held liable for non-delivery or mis-delivery arising from incorrect address information provided by the customer.</p>
          </div>
          <div className="sp-item">
            <span className="sp-dash">—</span>
            <p className="sp-text">Risk of loss and title for ordered products passes to you upon successful delivery to the address provided.</p>
          </div>
        </div>
      ),
    },
    {
      num: "06",
      eyebrow: "Undelivered",
      title: "Failed Delivery & RTO",
      content: (
        <div className="sp-items">
          <div className="sp-item">
            <span className="sp-dash">—</span>
            <p className="sp-text">If a delivery attempt fails due to the customer being unavailable, an incorrect address, or refusal to accept, the courier will typically make <strong>1–2 additional attempts</strong> before marking the shipment as RTO (Return to Origin).</p>
          </div>
          <div className="sp-item">
            <span className="sp-dash">—</span>
            <p className="sp-text">If your order is returned to us due to failed delivery, we will contact you at your registered email to arrange re-shipment. Re-shipment charges will apply and must be borne by the customer.</p>
          </div>
          <div className="sp-item">
            <span className="sp-dash">—</span>
            <p className="sp-text">Orders that are repeatedly undeliverable may be cancelled and refunded after deducting applicable shipping costs.</p>
          </div>
        </div>
      ),
    },
    {
      num: "07",
      eyebrow: "Damage",
      title: "Damaged in Transit",
      content: (
        <div className="sp-items">
          <div className="sp-item">
            <span className="sp-dash">—</span>
            <p className="sp-text">If your order arrives visibly damaged, please <strong>do not accept the delivery</strong> and ask the courier to mark it as "Damaged on Arrival." Take photographs of the packaging before opening.</p>
          </div>
          <div className="sp-item">
            <span className="sp-dash">—</span>
            <p className="sp-text">Report any transit damage to us at <strong>support@veshheon.in</strong> within <strong>48 hours</strong> of delivery with photographic evidence. We will assess and arrange a replacement or refund on a case-by-case basis.</p>
          </div>
          <div className="sp-item">
            <span className="sp-dash">—</span>
            <p className="sp-text">Claims raised beyond 48 hours of delivery may not be eligible for consideration.</p>
          </div>
        </div>
      ),
    },
    {
      num: "08",
      eyebrow: "Payments",
      title: "Cash on Delivery",
      content: (
        <div className="sp-items">
          <div className="sp-item">
            <span className="sp-dash">—</span>
            <p className="sp-text">Cash on Delivery (COD) is available for selected pin codes within India. Availability will be indicated at checkout based on your delivery address.</p>
          </div>
          <div className="sp-item">
            <span className="sp-dash">—</span>
            <p className="sp-text">COD orders must be paid in full in cash at the time of delivery. We are unable to process partial payments or digital payments at the doorstep.</p>
          </div>
          <div className="sp-item">
            <span className="sp-dash">—</span>
            <p className="sp-text">Repeated cancellations or refusals of COD orders may result in COD being disabled for your account on future orders.</p>
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <style>{spStyles}</style>

      <div className="sp-root">

        {/* ── HEADER ── */}
        <div className="sp-header">
          <div className="sp-header-left">
            <span className="sp-eyebrow">Last Updated · July 1, 2025</span>
            <h1 className="sp-title">Shipping <span className="sp-title-bold">Policy</span></h1>
          </div>
        </div>

        <div className="sp-rule-wrap"><hr className="sp-hr" /></div>

        {/* ── STATS ── */}
        <div className="sp-stats">
          <div className="sp-stat">
            <span className="sp-stat-num">3–5</span>
            <span className="sp-stat-label">Days to Dispatch</span>
            <span className="sp-stat-sub">Standard orders</span>
          </div>
          <div className="sp-stat-divider" />
          <div className="sp-stat">
            <span className="sp-stat-num">4–7</span>
            <span className="sp-stat-label">Days Delivery</span>
            <span className="sp-stat-sub">After dispatch</span>
          </div>
          <div className="sp-stat-divider" />
          <div className="sp-stat">
            <span className="sp-stat-num">48h</span>
            <span className="sp-stat-label">Damage Report</span>
            <span className="sp-stat-sub">Window from delivery</span>
          </div>
        </div>

        <div className="sp-rule-wrap"><hr className="sp-hr" /></div>

        {/* ── INTRO ── */}
        <div className="sp-intro-wrap">
          <p className="sp-pull">
            "Every VESHH-EON piece is crafted with intention. Our shipping process reflects the same care — ensuring your order reaches you safely, wherever you are."
          </p>
        </div>

        <div className="sp-rule-wrap"><hr className="sp-hr" /></div>

        {/* ── SECTIONS ── */}
        <div className="sp-sections">
          {sections.map((s, i) => {
            const words = s.title.split(" ");
            const light = words.slice(0, -1).join(" ");
            const bold = words[words.length - 1];
            return (
              <React.Fragment key={s.num}>
                <section className="sp-section">
                  <div className="sp-section-meta">
                    <span className="sp-section-num">{s.num}</span>
                    <div>
                      <span className="sp-section-eyebrow">{s.eyebrow}</span>
                      <h2 className="sp-section-title">
                        {light && <span className="sp-section-light">{light} </span>}
                        <span className="sp-section-bold">{bold}</span>
                      </h2>
                    </div>
                  </div>
                  <div className="sp-section-body">{s.content}</div>
                </section>
                {i < sections.length - 1 && (
                  <div className="sp-rule-wrap"><hr className="sp-hr" /></div>
                )}
              </React.Fragment>
            );
          })}
        </div>

        {/* ── CONTACT STRIP ── */}
        <div className="sp-rule-wrap"><hr className="sp-hr" /></div>
        <div className="sp-contact">
          <div className="sp-contact-left">
            <span className="sp-contact-eyebrow">Questions?</span>
            <span className="sp-contact-title">We're Here To Help</span>
          </div>
          <a href="mailto:support@veshheon.in" className="sp-contact-email">
            <span>support@veshheon.in</span>
            <span className="sp-contact-note">Response within 24 hours</span>
          </a>
        </div>

        <div className="sp-rule-wrap"><hr className="sp-hr" /></div>
        <div className="sp-closing">
          <span className="sp-closing-text">VESHH-EON · Shipping Policy · Belagavi, Karnataka, Bharat</span>
        </div>

      </div>
    </>
  );
}

const spStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Exo+2:ital,wght@0,200;0,300;0,400;0,500;0,600;1,300&display=swap');

  .sp-root {
    background: #f8f8f8;
    min-height: 100vh;
    font-family: 'Exo 2', sans-serif;
    padding-bottom: 80px;
  }

  /* ── HEADER ── */
  .sp-header {
    max-width: 1200px;
    margin: 0 auto;
    padding: 64px 80px 40px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }

  .sp-eyebrow {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 9px;
    font-weight: 400;
    letter-spacing: 0.5em;
    text-transform: uppercase;
    color: black;
    margin-bottom: 12px;
  }
  .sp-eyebrow::before {
    content: '';
    width: 24px;
    height: 1px;
    background: black;
    display: block;
    flex-shrink: 0;
  }

  .sp-title {
    font-size: clamp(32px, 4.5vw, 60px);
    font-weight: 200;
    color: #000;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    line-height: 1;
    margin: 0;
  }
  .sp-title-bold { font-weight: 600; }

  /* ── RULES ── */
  .sp-rule-wrap {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 80px;
  }
  .sp-hr {
    border: none;
    border-top: 1px solid black;
    margin: 0;
  }

  /* ── STATS ── */
  .sp-stats {
    max-width: 1200px;
    margin: 0 auto;
    padding: 52px 80px;
    display: flex;
    align-items: center;
  }

  .sp-stat {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 0 40px;
  }
  .sp-stat:first-child { padding-left: 0; }
  .sp-stat:last-child  { padding-right: 0; }

  .sp-stat-num {
    font-size: clamp(36px, 4vw, 56px);
    font-weight: 200;
    color: #000;
    letter-spacing: -0.02em;
    line-height: 1;
  }

  .sp-stat-label {
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.3em;
    text-transform: uppercase;
    color: #000;
  }

  .sp-stat-sub {
    font-size: 9px;
    font-weight: 300;
    letter-spacing: 0.2em;
    color: black;
    text-transform: uppercase;
  }

  .sp-stat-divider {
    width: 1px;
    height: 60px;
    background: black;
    flex-shrink: 0;
  }

  /* ── INTRO ── */
  .sp-intro-wrap {
    max-width: 1200px;
    margin: 0 auto;
    padding: 48px 80px;
  }

  .sp-pull {
    font-size: clamp(13px, 1.6vw, 17px);
    font-weight: 300;
    font-style: italic;
    color: black;
    line-height: 1.8;
    border-left: 2px solid black;
    padding-left: 20px;
    margin: 0;
    max-width: 680px;
    letter-spacing: 0.02em;
  }

  /* ── SECTIONS ── */
  .sp-sections {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 80px;
  }

  .sp-section {
    display: grid;
    grid-template-columns: 260px 1fr;
    gap: 60px;
    padding: 52px 0;
  }

  .sp-section-meta {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .sp-section-num {
    font-size: 64px;
    font-weight: 200;
    color: black;
    line-height: 1;
    letter-spacing: -0.02em;
    display: block;
  }

  .sp-section-eyebrow {
    display: block;
    font-size: 8px;
    font-weight: 400;
    letter-spacing: 0.45em;
    text-transform: uppercase;
    color: black;
    margin-bottom: 8px;
  }

  .sp-section-title {
    font-size: clamp(16px, 2vw, 28px);
    line-height: 1.1;
    margin: 0;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }
  .sp-section-light { font-weight: 200; color: #000; }
  .sp-section-bold  { font-weight: 600; color: #000; }

  .sp-section-body { padding-top: 6px; }

  .sp-text {
    font-size: 13px;
    font-weight: 300;
    color: black;
    line-height: 2;
    letter-spacing: 0.04em;
    text-align: justify;
    margin: 0;
  }

  .sp-items { display: flex; flex-direction: column; gap: 14px; }
  .sp-item  { display: flex; align-items: flex-start; gap: 14px; }

  .sp-dash {
    font-size: 13px;
    font-weight: 300;
    color: black;
    flex-shrink: 0;
    padding-top: 2px;
  }

  /* ── CONTACT STRIP ── */
  .sp-contact {
    max-width: 1200px;
    margin: 0 auto;
    padding: 48px 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
  }

  .sp-contact-left {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .sp-contact-eyebrow {
    font-size: 8px;
    font-weight: 400;
    letter-spacing: 0.45em;
    text-transform: uppercase;
    color: black;
  }

  .sp-contact-title {
    font-size: clamp(18px, 2.5vw, 28px);
    font-weight: 200;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #000;
  }

  .sp-contact-email {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    text-decoration: none;
  }

  .sp-contact-email > span:first-child {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.08em;
    color: #000;
    position: relative;
    padding-bottom: 3px;
  }
  .sp-contact-email > span:first-child::after {
    content: '';
    position: absolute;
    bottom: 0; left: 0;
    width: 100%;
    height: 1px;
    background: black;
    transition: background 0.25s ease;
  }
  .sp-contact-email:hover > span:first-child::after { background: #000; }

  .sp-contact-note {
    font-size: 8px;
    font-weight: 300;
    letter-spacing: 0.25em;
    text-transform: uppercase;
    color: black;
  }

  /* ── CLOSING ── */
  .sp-closing {
    max-width: 1200px;
    margin: 0 auto;
    padding: 24px 80px 0;
    text-align: center;
  }

  .sp-closing-text {
    font-size: 8px;
    font-weight: 300;
    letter-spacing: 0.35em;
    text-transform: uppercase;
    color: black;
  }

  /* ── RESPONSIVE ── */
  @media (max-width: 1024px) {
    .sp-header     { padding: 48px 40px 32px; }
    .sp-rule-wrap  { padding: 0 40px; }
    .sp-stats      { padding: 40px 40px; }
    .sp-stat       { padding: 0 24px; }
    .sp-intro-wrap { padding: 40px 40px; }
    .sp-sections   { padding: 0 40px; }
    .sp-contact    { padding: 40px 40px; }
    .sp-closing    { padding: 20px 40px 0; }
    .sp-section    { grid-template-columns: 200px 1fr; gap: 40px; }
  }

  @media (max-width: 768px) {
    .sp-header     { padding: 40px 20px 28px; flex-direction: column; align-items: flex-start; gap: 16px; }
    .sp-rule-wrap  { padding: 0 20px; }
    .sp-stats      { padding: 36px 20px; flex-direction: column; align-items: flex-start; gap: 28px; }
    .sp-stat       { padding: 0; }
    .sp-stat-divider { width: 40px; height: 1px; }
    .sp-intro-wrap { padding: 36px 20px; }
    .sp-sections   { padding: 0 20px; }
    .sp-contact    { flex-direction: column; align-items: flex-start; padding: 36px 20px; gap: 20px; }
    .sp-contact-email { align-items: flex-start; }
    .sp-closing    { padding: 20px 20px 0; }
    .sp-section    { grid-template-columns: 1fr; gap: 20px; padding: 40px 0; }
    .sp-section-meta { flex-direction: row; align-items: flex-end; gap: 14px; }
    .sp-section-num  { font-size: 44px; }
  }

  @media (max-width: 360px) {
    .sp-header     { padding: 32px 14px 24px; }
    .sp-rule-wrap  { padding: 0 14px; }
    .sp-stats      { padding: 28px 14px; }
    .sp-intro-wrap { padding: 28px 14px; }
    .sp-sections   { padding: 0 14px; }
    .sp-contact    { padding: 28px 14px; }
    .sp-closing    { padding: 16px 14px 0; }
  }
`;
